import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { FILTER_COLOR } from 'dpl/constants/query_params';
import useSearchQueryFilter from 'dpl/breeder_search_results/hooks/useSearchQueryFilter';
import { isMobileUA } from 'dpl/shared/utils';

import ExpandableChecklist from './ExpandableChecklist';
import { COLOR_TYPES } from '../utils/constants';

const IS_MOBILE = isMobileUA();

export default function ColorFilter({ title, filterOptions }) {
  const { searchQueryFilterValues, toggleFilter } =
    useSearchQueryFilter(FILTER_COLOR);

  const nonStandardColors = useMemo(
    () =>
      (filterOptions || []).find(
        opt => opt[0] === COLOR_TYPES.NON_STANDARD
      )?.[1] || [],
    [filterOptions]
  );
  const standardColors = useMemo(
    () =>
      (filterOptions || []).find(opt => opt[0] === COLOR_TYPES.STANDARD)?.[1] ||
      [],
    [filterOptions]
  );

  const allColors = useMemo(
    () =>
      [
        standardColors.length > 0 && {
          label: COLOR_TYPES.STANDARD
        },
        ...standardColors,
        nonStandardColors.length > 0 && {
          label: COLOR_TYPES.NON_STANDARD
        },
        ...nonStandardColors
      ].filter(Boolean),
    [nonStandardColors, standardColors]
  );

  return (
    <>
      {title && (
        <p className="mb4 font-16 fw-medium md:font-18 md:font-serif">
          {title}
        </p>
      )}
      {IS_MOBILE ? (
        <div className="SearchFiltersColorFilter">
          <ExpandableChecklist
            checklistName={FILTER_COLOR}
            seeMoreAfter={6}
            options={allColors}
            values={searchQueryFilterValues}
            onChange={e => toggleFilter(Number(e.target.value))}
          />
        </div>
      ) : (
        <div className="SearchResultFiltersColorFilter row">
          {standardColors.length > 0 && (
            <div className="col-md-6 col-12">
              <p className="mb4 font-14 fw-medium">{COLOR_TYPES.STANDARD}</p>
              <ExpandableChecklist
                checklistName={FILTER_COLOR}
                seeMoreAfter={5}
                options={standardColors}
                values={searchQueryFilterValues}
                onChange={e => toggleFilter(Number(e.target.value))}
              />
            </div>
          )}
          {nonStandardColors.length > 0 && (
            <div className="col-md-6 col-12">
              <p className="mb4 mt4 mt0-md font-14 fw-medium">
                {COLOR_TYPES.NON_STANDARD}
              </p>
              <ExpandableChecklist
                checklistName={FILTER_COLOR}
                seeMoreAfter={5}
                options={nonStandardColors}
                values={searchQueryFilterValues}
                onChange={e => toggleFilter(Number(e.target.value))}
              />
            </div>
          )}
        </div>
      )}
    </>
  );
}

ColorFilter.propTypes = {
  title: PropTypes.string,
  filterOptions: PropTypes.arrayOf(PropTypes.array).isRequired
};

ColorFilter.defaultProps = {
  title: null
};
